var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 42 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#005CA9",
    d: "M4.5 0A4.5 4.5 0 0 0 0 4.5v2.379q.117.042.228.096l19.794 9.555c.618.3 1.338.3 1.956 0l19.794-9.555.228-.096V4.5A4.5 4.5 0 0 0 37.5 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#005CA9",
    d: "M42 11.862 23.934 20.58a6.75 6.75 0 0 1-5.868 0L0 11.862V25.5A4.5 4.5 0 0 0 4.5 30h33a4.5 4.5 0 0 0 4.5-4.5z"
  })));
};
export default SvgMail;